export enum NetworkID {
  MAINNET = 1,
  GOERLI = 5,
}